import {useMutation, useQueryClient} from '@tanstack/react-query'
import * as sdk from '@cypro/server/sdk'

async function uploadLogoFn(file: File) {
  const {data} = await sdk.uploadLogo({body: {logo: file}})

  return data || null
}

export function useUploadLogo() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: uploadLogoFn,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['settings']})
    },
  })
}
